export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_META = {
  new: { label: "New", cls: "bg-amber/25 text-amberdark border-amber/60" },
  contacted: { label: "Contacted", cls: "bg-sky-100 text-sky-700 border-sky-200" },
  site_visit: { label: "Site Visit", cls: "bg-teal-100 text-teal-700 border-teal-200" },
  negotiation: { label: "Negotiation", cls: "bg-orange-100 text-orange-700 border-orange-200" },
  won: { label: "Won", cls: "bg-green-100 text-green-700 border-green-200" },
  lost: { label: "Lost", cls: "bg-gray-100 text-gray-500 border-gray-300" },
};
export const STATUS_ORDER = ["new", "contacted", "site_visit", "negotiation", "won", "lost"];

export const PROP_TYPES = {
  land: "Land / Plot",
  pg_building: "PG Building",
  residential: "Residential",
  commercial: "Commercial",
};
export const PROP_STATUS = {
  available: { label: "Available", cls: "bg-green-100 text-green-700 border-green-200" },
  reserved: { label: "Reserved", cls: "bg-amber/25 text-amberdark border-amber/60" },
  sold: { label: "Sold via Veera", cls: "bg-gray-100 text-gray-500 border-gray-300" },
  lost: { label: "Lost (external deal)", cls: "bg-red-100 text-red-600 border-red-200" },
};

export const INTERESTS = [
  "Direct call / walk-in",
  "Rental income",
  "Own-use",
  "Commercial",
  "Development",
  "Land search & advisory",
  "Unsure / exploring",
];

export const SOURCE_META = {
  website: { label: "Website", cls: "bg-sky-100 text-sky-700 border-sky-200" },
  whatsapp: { label: "WhatsApp", cls: "bg-green-100 text-green-700 border-green-200" },
  instagram: { label: "Instagram", cls: "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200" },
  manual: { label: "Manual", cls: "bg-gray-100 text-gray-600 border-gray-300" },
};

export const ROLE_LABELS = { cofounder: "Co-founder", manager: "Manager", staff: "Staff" };export const ROLE_BADGE = {
  cofounder: "bg-navy text-amber",
  manager: "bg-amber/25 text-amberdark",
  staff: "bg-cream text-gray-600",
};

export const emptyLead = { name: "", phone: "", email: "", city: "", interest: INTERESTS[0], message: "" };
export const emptyProp = { name: "", type: "land", city: "", location: "", size_sqft: "", price: "", notes: "", client_id: "" };

export const formatError = (detail) => {
  if (detail == null) return "Cannot reach the server. Check your internet connection and try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};
